import React from 'react';
import { Row, Col, Modal, ModalHeader, ModalBody, ModalFooter, Input, Button } from 'reactstrap';

class SettingsDialogPC extends React.Component {
  constructor(props) {
    super();
    this.state = {
      numAuthor: props.settings ? props.settings.teamCount : 10,
      numOrganism: props.settings ? props.settings.organismCount : 10,
      numPublication: props.settings ? props.settings.publicationCount : 10,
    };
  }

  onApply = (() => {
    let settings = {
      teamCount: +this.state.numAuthor,
      organismCount: +this.state.numOrganism,
      publicationCount: +this.state.numPublication,
    };
    this.props.onApply(settings);
  }).bind(this)

  render() {
    return (
      <Modal isOpen={this.props.isOpen} toggle={this.props.toggle}>
        <ModalHeader>Comparison View Settings</ModalHeader>
        <ModalBody>
          <Row>
            <Col sm={4}>
              Author number
            </Col>
            <Col>
              <Input
                type='number'
                onChange={(e) => {
                  this.setState({numAuthor: e.target.value});
                }}
                value={this.state.numAuthor}
              />
            </Col>
          </Row>
          <Row>
            <Col sm={4}>
              Organism number
            </Col>
            <Col>
              <Input
                type='number'
                onChange={(e) => {
                  this.setState({numOrganism: e.target.value});
                }}
                value={this.state.numOrganism}
              />
            </Col>
          </Row>
          <Row>
            <Col sm={4}>
              Publication number
            </Col>
            <Col>
              <Input
                type='number'
                onChange={(e) => {
                  this.setState({numPublication: e.target.value});
                }}
                value={this.state.numPublication}
              />
            </Col>
          </Row>
        </ModalBody>
        <ModalFooter>
          <Button color='primary' onClick={this.onApply}>Apply</Button>
          <Button color='secondary' onClick={this.props.toggle}>Close</Button>
        </ModalFooter>
      </Modal>
    )
  }
}

export default SettingsDialogPC;
